module.exports = __webpack_public_path__ + "static/media/redeem-success.4f3e2e59.png";